import React, { useState, useMemo, useEffect } from 'react';
import { ArrowLeft, User, Users, Calendar, Mail, Phone, FileText, CreditCard, AlertCircle } from 'lucide-react';
import BookingLoadingOverlay from '../components/BookingLoadingOverlay';
import Swal from 'sweetalert2';

export default function DevisPage({ 
  hotel, 
  selectedPension, 
  selectedRoomVariants, 
  selectedAllocation,
  searchData, 
  currentBalance,
  currentMargin,
  margeB2B,
  onBalanceUpdate, 
  onNavigateToRecharge 
}) {


    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isBookingLoading, setIsBookingLoading] = useState(false);



const [formData, setFormData] = useState(() => {


  

  let passengers = [];

  if (selectedAllocation && Array.isArray(selectedAllocation) && selectedAllocation.length > 0) {
    passengers = selectedAllocation.map((allocRoom, idx) => {
      const roomVariant = selectedRoomVariants[allocRoom.slotIndex];
      
      if (!roomVariant) {
        return null;
      }

      const adultsCount = allocRoom.requestedAdults || 0;
      const childrenCount = allocRoom.requestedChildren || 0;

      // ✅ GET CHILD AGES FROM SEARCHDATA
      const requestedRoom = searchData?.rooms?.[allocRoom.slotIndex];
      const childAges = requestedRoom?.children || [];


      return {
        roomVariant: roomVariant,
        adults: Array.from({ length: adultsCount }, () => ({ nom: '', prenom: '' })),
        // ✅ PRE-FILL CHILD AGES
        children: Array.from({ length: childrenCount }, (_, childIdx) => ({ 
          nom: '', 
          prenom: '', 
          age: childAges[childIdx] || 0  // ✅ Use age from searchData
        }))
      };
    }).filter(p => p !== null);
  } else {
  }


  return {
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    notes: '',
    passengers: passengers
  };
});



  // Calculate nights
const calculateNights = useMemo(() => {
  if (!searchData?.checkIn || !searchData?.checkOut) return 3;
  
  
  // Parse French date format "DD/MM/YYYY"
  const parseDate = (dateStr) => {
    if (dateStr instanceof Date) return dateStr;
    
    // Handle "DD/MM/YYYY" format
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0]);
      const month = parseInt(parts[1]) - 1; // Month is 0-indexed
      const year = parseInt(parts[2]);
      return new Date(year, month, day);
    }
    
    // Fallback to default parsing
    return new Date(dateStr);
  };
  
  const checkIn = parseDate(searchData.checkIn);
  const checkOut = parseDate(searchData.checkOut);
  
  
  const diffTime = Math.abs(checkOut - checkIn);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  
  return diffDays || 3;
}, [searchData]);

  // Calculate prices
// ✅ CORRECT
const prices = useMemo(() => {
  if (!selectedRoomVariants || Object.keys(selectedRoomVariants).length === 0) {
    return { totalPurchase: 0, totalSale: 0, commission: 0 };
  }

  const roomPrices = Object.values(selectedRoomVariants);
  const totalPurchase = roomPrices.reduce((sum, room) => sum + parseFloat(room.price), 0);  // ✅ No multiplication!
  
  return {
    totalPurchase: parseFloat(totalPurchase.toFixed(3)),
    totalSale: parseFloat(totalPurchase.toFixed(3)),
    commission: 0,
    perNight: parseFloat((totalPurchase / calculateNights).toFixed(3))  // ✅ Divide to get per night
  };
}, [selectedRoomVariants, calculateNights]);


  const formatPrice = (price) => {
    return parseFloat(price).toFixed(3);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.nom || !formData.prenom || !formData.email || !formData.telephone) {
      Swal.fire({
        icon: 'error',
        title: 'Informations manquantes',
        text: 'Veuillez remplir tous les champs obligatoires',
        confirmButtonColor: '#FF7B47'
      });
      return;
    }

    // Check balance
if (currentBalance < prices.totalPurchase) {
  Swal.fire({
    icon: 'error',
    title: 'Solde insuffisant',
    html: `
      <p>Votre solde actuel: <strong>${formatPrice(currentBalance)} TND</strong></p>
      <p>Montant requis: <strong>${formatPrice(prices.totalPurchase)} TND</strong></p>
      <p class="text-red-600 font-semibold">Manque: ${formatPrice(prices.totalPurchase - currentBalance)} TND</p>
    `,
    showCancelButton: true,
    confirmButtonText: 'Recharger mon solde',
    cancelButtonText: 'Annuler',
    confirmButtonColor: '#10b981',
    cancelButtonColor: '#6b7280',
  }).then((result) => {
    if (result.isConfirmed) {
      onNavigateToRecharge();
    }
  });
  return;
}

    // Confirmation
const result = await Swal.fire({
  icon: 'question',
  title: 'Confirmer la réservation',
  html: `
    <div class="text-left space-y-2">
      <p><strong>Hôtel:</strong> ${hotel.name}</p>
      <p><strong>Client:</strong> ${formData.prenom} ${formData.nom}</p>
      <p><strong>Séjour:</strong> ${calculateNights} nuit(s)</p>
      <p><strong>Prix total:</strong> ${formatPrice(prices.totalPurchase)} TND</p>
      <p class="pt-2 border-t"><strong>Nouveau solde:</strong> ${formatPrice(currentBalance - prices.totalPurchase)} TND</p>
    </div>
  `,
  showCancelButton: true,
  confirmButtonText: 'Confirmer',
  cancelButtonText: 'Annuler',
  confirmButtonColor: '#FF7B47',
  cancelButtonColor: '#6b7280',
});

    if (!result.isConfirmed) return;

    try {
      // Format dates properly (YYYY-MM-DD)
const formatDateForDB = (dateStr) => {
  if (!dateStr) return null;
  
  // If already in YYYY-MM-DD format
  if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return dateStr;
  }
  
  // Parse French format DD/MM/YYYY
  if (typeof dateStr === 'string' && dateStr.includes('/')) {
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }
  }
  
  // Fallback: treat as Date object
  const d = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

      // Prepare reservation data

      const reservationData = {
  hotelId: hotel.id,
  hotelName: hotel.name,
  checkIn: formatDateForDB(searchData.checkIn),
  checkOut: formatDateForDB(searchData.checkOut),

  // ✅ FIXED field paths
  cityId: searchData.cityId || searchData.destinationId,
  source: hotel.rawData?.Source || 'local-2',
  optionIds: [],

  client: {
    nom: formData.nom,
    prenom: formData.prenom,
    email: formData.email,
    telephone: formData.telephone
  },

  rooms: formData.passengers.map((passenger, idx) => {
    const roomVariant = passenger.roomVariant;
    return {
      roomName: roomVariant.name,
      pensionName: selectedPension.label,
      pensionCode: selectedPension.code,
      purchasePrice: roomVariant.purchasePrice,
      salePrice: roomVariant.price,
      commission: roomVariant.partnerProfit,
      onRequest: roomVariant.onRequest === true,

      // ✅ FIXED — boardingId comes from selectedPension, not roomVariant
      mygoRoomId:        roomVariant.id,
      mygoBoardingId:    selectedPension.boardingId,
      mygoViewIds:       roomVariant.viewIds || roomVariant.view?.map(v => v.Id ?? v) || [],
      mygoSupplementIds: roomVariant.supplementIds || [],

      adults: passenger.adults.map((adult, adultIdx) => ({
        nom: adult.nom?.trim() || `Passager adulte ${adultIdx + 1}`,
        prenom: adult.prenom?.trim() || ''
      })),
      children: passenger.children.map((child, childIdx) => ({
        nom: child.nom?.trim() || `Passager enfant ${childIdx + 1}`,
        prenom: child.prenom?.trim() || '',
        age: child.age || 0
      }))
    };
  }),

  totalPurchasePrice: Object.values(selectedRoomVariants).reduce((sum, r) => sum + r.purchasePrice, 0),
  totalSalePrice: Object.values(selectedRoomVariants).reduce((sum, r) => sum + r.price, 0),
  commission: Object.values(selectedRoomVariants).reduce((sum, r) => sum + r.partnerProfit, 0),
  margeB2B: margeB2B,
  margePartenaire: currentMargin,
  notes: formData.notes || ''
};



// const reservationData = {
//   hotelId: hotel.id,
//   hotelName: hotel.name,
//   checkIn: formatDateForDB(searchData.checkIn),
//   checkOut: formatDateForDB(searchData.checkOut),

//   cityId: searchData.cityId,
//   source: hotel.source || 'local-2',
//   optionIds: [],


//   client: {
//     nom: formData.nom,
//     prenom: formData.prenom,
//     email: formData.email,
//     telephone: formData.telephone
//   },
// rooms: formData.passengers.map((passenger, idx) => {
//   const roomVariant = passenger.roomVariant;
  
//   // ✅ UPDATED: Use placeholders for empty passenger names
//   return {
//     roomName: roomVariant.name,
//     pensionName: selectedPension.label,
//     pensionCode: selectedPension.code,
//     purchasePrice: roomVariant.purchasePrice,
//     salePrice: roomVariant.price,
//     commission: roomVariant.partnerProfit,
//     onRequest: roomVariant.onRequest === true,

//       mygoRoomId:        roomVariant.id,
//       mygoBoardingId:    roomVariant.boardingId,
//       mygoViewIds:       roomVariant.viewIds || roomVariant.view?.map(v => v.Id || v) || [],
//       mygoSupplementIds: roomVariant.supplementIds || [],
    
//     // ✅ Map adults, use "Passager adulte X" if empty
//     adults: passenger.adults.map((adult, adultIdx) => ({
//       nom: adult.nom?.trim() || `Passager adulte ${adultIdx + 1}`,
//       prenom: adult.prenom?.trim() || ''
//     })),
    
//     // ✅ Map children, use "Passager enfant X" if empty
//     children: passenger.children.map((child, childIdx) => ({
//       nom: child.nom?.trim() || `Passager enfant ${childIdx + 1}`,
//       prenom: child.prenom?.trim() || '',
//       age: child.age || 0
//     }))
//   };
// }),
//   totalPurchasePrice: Object.values(selectedRoomVariants).reduce((sum, room) => sum + room.purchasePrice, 0),  // ✅ Total partner pays
//   totalSalePrice: Object.values(selectedRoomVariants).reduce((sum, room) => sum + room.price, 0),             // ✅ Total client pays
//   commission: Object.values(selectedRoomVariants).reduce((sum, room) => sum + room.partnerProfit, 0),         // ✅ Total profit
//   margeB2B: margeB2B,
//   margePartenaire: currentMargin,
//   notes: formData.notes || ''
// };



      const token = localStorage.getItem('authToken');
      
      if (!token) {
        throw new Error('Session expirée, veuillez vous reconnecter');
      }


setIsBookingLoading(true); 
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reservations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(reservationData)
      });

       setIsBookingLoading(false);


      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Server error response:', errorText);
        
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch (e) {
          throw new Error(`Erreur serveur (${response.status}): ${errorText.substring(0, 100)}`);
        }
        
        throw new Error(errorData.error || 'Erreur lors de la création de la réservation');
      }

      const data = await response.json();

      // Update balance
      onBalanceUpdate(data.newBalance);

if (data.surDemande) {
  await Swal.fire({
    icon: 'info',
    title: '⏳ Demande Envoyée!',
    html: `
      <p>Votre réservation <strong>${data.refCommande}</strong> est en attente de confirmation.</p>
      <p style="color: #FF7B47; margin-top: 10px;">
        ⚠️ Aucun montant n'a été débité de votre solde pour le moment.
      </p>
      <p style="color: #666; font-size: 14px; margin-top: 10px;">
        GOmax contactera l'hôtel et vous notifiera par email sous 24-48h.
      </p>
    `,
    confirmButtonColor: '#2B4979',
    confirmButtonText: 'Compris!'
  });
} else {
  await Swal.fire({
    icon: 'success',
    title: '✅ Réservation Confirmée!',
    html: `
      <p>Référence: <strong>${data.refCommande}</strong></p>
      <p>Votre devis a été enregistré avec succès.</p>
    `,
    confirmButtonText: 'OK',
    confirmButtonColor: '#10b981',
  });
}

window.location.href = '/';

    } catch (error) {
      setIsBookingLoading(false);
      console.error('Reservation error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: error.message || 'Impossible de créer la réservation',
        confirmButtonColor: '#FF7B47'
      });
    }
  };

  const updatePassenger = (roomIdx, type, personIdx, field, value) => {
    const newPassengers = [...formData.passengers];
    newPassengers[roomIdx][type][personIdx][field] = value;
    setFormData({ ...formData, passengers: newPassengers });
  };

  if (!selectedRoomVariants || Object.keys(selectedRoomVariants).length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <AlertCircle size={48} className="text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-700 mb-2">Aucune chambre sélectionnée</h2>
          <p className="text-gray-500 mb-4">Veuillez retourner et sélectionner des chambres</p>
          <button
            onClick={() => window.history.back()}
            className="bg-[#FF7B47] text-white px-6 py-3 rounded-lg hover:bg-[#ff6a30]"
          >
            Retour
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={() => window.history.back()}
          className="mb-6 flex items-center gap-2 text-[#2B4979] hover:text-[#FF7B47] font-semibold transition group"
        >
          <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
          Retour
        </button>

        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-[#2B4979] mb-8">
            Demande de devis
          </h1>

          <div className="grid lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 space-y-6">
              {/* Hotel Info */}
              <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-[#FF7B47]">
                <h3 className="font-bold text-xl text-[#2B4979] mb-4">{hotel.name}</h3>
                <div className="grid md:grid-cols-3 gap-4 text-sm">
                  <div className="flex items-center gap-2">
                    <Calendar className="text-[#FF7B47]" size={16} />
                    <div>
                      <div className="text-gray-500">Séjour</div>
                      <div className="font-semibold">{calculateNights} nuits</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Users className="text-[#FF7B47]" size={16} />
                    <div>
                      <div className="text-gray-500">Chambres</div>
                      <div className="font-semibold">{Object.keys(selectedRoomVariants).length} chambre(s)</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <CreditCard className="text-[#FF7B47]" size={16} />
                    <div>
                      <div className="text-gray-500">Formule</div>
                      <div className="font-semibold">{selectedPension?.label}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Client Info */}
              <div className="bg-white rounded-xl shadow-md p-6">
                <div className="flex items-center gap-3 mb-6">
                  <div className="bg-[#FF7B47] p-2 rounded-lg">
                    <User className="text-white" size={24} />
                  </div>
                  <h2 className="text-xl font-bold text-[#2B4979]">Informations Client</h2>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Nom *</label>
                    <input
                      type="text"
                      value={formData.nom}
                      onChange={(e) => setFormData({...formData, nom: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF7B47] focus:outline-none transition"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Prénom *</label>
                    <input
                      type="text"
                      value={formData.prenom}
                      onChange={(e) => setFormData({...formData, prenom: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF7B47] focus:outline-none transition"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Email *</label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                      <input
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF7B47] focus:outline-none transition"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Téléphone *</label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                      <input
                        type="tel"
                        value={formData.telephone}
                        onChange={(e) => setFormData({...formData, telephone: e.target.value})}
                        className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF7B47] focus:outline-none transition"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Passengers Info */}
<div className="bg-white rounded-xl shadow-md p-6">
  <div className="flex items-center gap-3 mb-6">
    <div className="bg-[#2B4979] p-2 rounded-lg">
      <Users className="text-white" size={24} />
    </div>
    <h2 className="text-xl font-bold text-[#2B4979]">
      Informations Passagers <span className="text-gray-500 font-normal text-lg">(Optionnel)</span>
    </h2>
  </div>

                <div className="space-y-6">
                  {formData.passengers.map((room, roomIdx) => (
                    <div key={roomIdx} className="border-2 border-gray-200 rounded-lg p-5">
                      <h3 className="font-bold text-lg text-[#2B4979] mb-2 pb-2 border-b">
                        Chambre {roomIdx + 1}: {room.roomVariant.name}
                      </h3>
                      
 {/* Adults */}
{room.adults.length > 0 && (
  <div className="mb-4">
    <h4 className="font-semibold text-[#2B4979] mb-3 flex items-center gap-2">
      <User size={16} className="text-[#FF7B47]" />
      Adultes ({room.adults.length})
    </h4>
    <div className="space-y-3">
      {room.adults.map((adult, adultIdx) => (
        <div key={adultIdx} className="grid grid-cols-2 gap-3 bg-gray-50 p-3 rounded-lg">
          <div>
            <label className="block text-xs text-gray-600 mb-1">
              Nom de l'adulte {adultIdx + 1}
            </label>
            <input
              type="text"
              value={adult.nom}
              onChange={(e) => updatePassenger(roomIdx, 'adults', adultIdx, 'nom', e.target.value)}
              placeholder="Nom (optionnel)"  // ✅ ADD PLACEHOLDER
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:border-[#FF7B47] focus:outline-none text-sm"
              // ✅ REMOVE required
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">
              Prénom de l'adulte {adultIdx + 1}
            </label>
            <input
              type="text"
              value={adult.prenom}
              onChange={(e) => updatePassenger(roomIdx, 'adults', adultIdx, 'prenom', e.target.value)}
              placeholder="Prénom (optionnel)"  // ✅ ADD PLACEHOLDER
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:border-[#FF7B47] focus:outline-none text-sm"
              // ✅ REMOVE required
            />
          </div>
        </div>
      ))}
    </div>
  </div>
)}


{/* Children */}
{room.children.length > 0 && (
  <div>
    <h4 className="font-semibold text-[#2B4979] mb-3 flex items-center gap-2">
      <Users size={16} className="text-[#FF7B47]" />
      Enfants ({room.children.length})
    </h4>
    <div className="space-y-3">
      {room.children.map((child, childIdx) => (
        <div key={childIdx} className="grid grid-cols-3 gap-3 bg-blue-50 p-3 rounded-lg">
          <div>
            <label className="block text-xs text-gray-600 mb-1">
              Nom de l'enfant {childIdx + 1}
            </label>
            <input
              type="text"
              value={child.nom}
              onChange={(e) => updatePassenger(roomIdx, 'children', childIdx, 'nom', e.target.value)}
              placeholder="Nom (optionnel)"  // ✅ ADD PLACEHOLDER
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:border-[#FF7B47] focus:outline-none text-sm"
              // ✅ REMOVE required
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">
              Prénom de l'enfant {childIdx + 1}
            </label>
            <input
              type="text"
              value={child.prenom}
              onChange={(e) => updatePassenger(roomIdx, 'children', childIdx, 'prenom', e.target.value)}
              placeholder="Prénom (optionnel)"  // ✅ ADD PLACEHOLDER
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:border-[#FF7B47] focus:outline-none text-sm"
              // ✅ REMOVE required
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">Âge</label>
            <input
              type="number"
              value={child.age}
              disabled
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 cursor-not-allowed text-sm"
            />
          </div>
        </div>
      ))}
    </div>
  </div>
)}


                    </div>
                  ))}
                </div>
              </div>

              {/* Notes */}
              <div className="bg-white rounded-xl shadow-md p-6">
                <div className="flex items-center gap-3 mb-6">
                  <div className="bg-green-500 p-2 rounded-lg">
                    <FileText className="text-white" size={24} />
                  </div>
                  <h2 className="text-xl font-bold text-[#2B4979]">Notes supplémentaires</h2>
                </div>

                <textarea
                  value={formData.notes}
                  onChange={(e) => setFormData({...formData, notes: e.target.value})}
                  rows="4"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF7B47] focus:outline-none transition"
                  placeholder="Demandes spéciales, préférences..."
                />
              </div>

              <button
                onClick={handleSubmit}
                className="w-full bg-[#FF7B47] hover:bg-[#ff6a30] text-white font-bold py-4 rounded-lg transition duration-200 transform hover:scale-[1.02] shadow-xl text-lg"
              >
                Confirmer la réservation
              </button>
            </div>

            {/* Summary */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-md p-6 sticky top-24">
                <h2 className="text-xl font-bold text-[#2B4979] mb-6">Récapitulatif</h2>
                
<div className="space-y-4 mb-6">
  <div className="flex justify-between text-sm text-gray-600">
    <span>Prix total</span>
    <span className="font-semibold">{formatPrice(prices.totalPurchase)} TND</span>
  </div>
  
  <div className="text-xs text-gray-500 mt-1">
    pour {calculateNights} nuit(s)
  </div>
  
  <div className="border-t pt-4">
    <div className="flex justify-between text-lg font-bold text-[#2B4979]">
      <span>Total à payer</span>
      <span className="text-[#FF7B47]">{formatPrice(prices.totalPurchase)} TND</span>
    </div>
  </div>
</div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded mb-4">
                  <div className="flex items-start gap-2">
                    <CreditCard className="text-blue-600 mt-1" size={18} />
                    <div className="text-sm">
                      <div className="font-semibold text-blue-900 mb-1">Votre solde</div>
                      <div className="text-blue-700">{formatPrice(currentBalance)} TND</div>
                    </div>
                  </div>
                </div>

                {currentBalance < prices.totalSale && (
                  <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                    <div className="flex items-start gap-2">
                      <AlertCircle className="text-red-600 mt-1" size={18} />
                      <div className="text-sm text-red-700">
                        <div className="font-semibold mb-1">Solde insuffisant</div>
                        <div>Manque: {formatPrice(prices.totalSale - currentBalance)} TND</div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="bg-gray-50 p-4 rounded-lg text-xs text-gray-600 mt-4">
                  <p className="mb-2">✓ Confirmation instantanée</p>
                  <p className="mb-2">✓ Prix avec votre marge incluse</p>
                  <p>✓ Support 24/7</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookingLoadingOverlay visible={isBookingLoading} />
    </div>
  );
}